import React from 'react'
import Spinner from 'react-bootstrap/Spinner'
import ProgressBarLoader from '../ProgressBar/ProgressBar'
import { WORKING_MAGIC_MESSAGE } from '../../constants/messages'

import './LoadingBox.css'

export const LoadingBox = ({ className = '', showProgressBar, progress, message = WORKING_MAGIC_MESSAGE }) => {
  return (
    <div className={`loading-box ${className}`}>
      {showProgressBar ? (
        <ProgressBarLoader now={progress} progressBarMessage={message} />
      ) : (
        <>
          <Spinner animation="border" />
          <div className="mt-3">{message}</div>
        </>
      )}
    </div>
  )
}
